import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { WorkflowAuditResult } from './audit.service';
import {
  FUIPopoverService,
  FUIPopoverRef
} from '@fry/ui-material/popover';
import {
  WorkflowAuditIssueListComponent,
  WorkflowAuditIssueListComponentData
} from './audit-issue-list.component';

@Component({
    selector: 'eas-workflow-audit-result-button',
    templateUrl: './audit-result-button.component.html',
    standalone: false
})
export class WorkflowAuditResultButtonComponent implements OnInit {
  @Input() result!: WorkflowAuditResult;
  @ViewChild('showResultsButton', { read: ElementRef }) showResultsButton!: ElementRef;

  private popoverRef?: FUIPopoverRef<WorkflowAuditIssueListComponentData>;

  constructor(private auditResultOverlay: FUIPopoverService) { }

  public ngOnInit(): void {
    this.popoverRef?.afterClosed$.subscribe(() => {
    });
  }

  public onShowResults(): void {
    this.popoverRef =
      this.auditResultOverlay.open<WorkflowAuditIssueListComponentData>({
        origin: this.showResultsButton.nativeElement,
        content: WorkflowAuditIssueListComponent,
        data: { issues: this.result.issues },
        width: 500,
        height: 600
      });
  }
}
